import './index.scss';
import React, { useState, useEffect, Fragment } from 'react';
import { DatePicker } from 'antd-mobile';
import moment from 'moment';
  
/**
 * Filter组件中的时间filter
 * @param {*} props 
 */

const FilterDateGroup = (props) => {

  const { onChange = () => {}, value, format, mode, single } = props;

  const [ timeVisable, setVisable ] = useState(false);

  const [ index, setIndex ] = useState(null);

  const handleShow = (_index) => {
    setIndex(_index);
    setVisable(true);
  }
  
  const handleHide = () => {
    onChange( ['', '']);
    setVisable(false);
  }

  const handleOk = (data) => {
    value[index] = data;
    onChange(value);
    setVisable(false);
  }

  useEffect(() => {
    onChange(['', '']);
  }, [onChange, ])

  return (
    <Fragment>
      {
        single ? 
        <PickerTempLate title="时间" format={format} value={value[0]} className="filter-time-picker" handleClick={() => { handleShow(0)} }></PickerTempLate>:
        <>
          <PickerTempLate title="开始时间" format={format} value={value[0]} className="filter-time-picker" handleClick={() => { handleShow(0)} }></PickerTempLate>
          <PickerTempLate title="结束时间" format={format} value={value[1]} className="filter-time-picker" handleClick={() => { handleShow(1)} } ></PickerTempLate>
        </>

      }
      <DatePicker
          mode={mode}
          visible={timeVisable}
          value={value[index]}
          onOk={handleOk}
          onDismiss={handleHide}
      />
    </Fragment>
  )
}

const PickerTempLate = (props) => {
  const { value, title, className, format, handleClick } = props;
  return (
    <span className={className} onClick={handleClick}>
      <div>
        <input className="picker-input" readOnly placeholder={title} value={value ? moment(value).format(format) : ''}>
        </input> 
        <i aria-label="图标: calendar" className="picker-icon">
          <svg viewBox="0 0 1024 1024" focusable="false"data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path></svg>
        </i>
      </div>
    </span>
  )
}

export default FilterDateGroup;